import { linkSystemProductsTranslations } from "./index";

export const LINK_SYSTEM_PRODUCTS_FR_FR: linkSystemProductsTranslations = {
	title: "Importer un produit",
	subtitle: "Liez les produits importés aux données de produits Zig",
	helpText:
		"Vous pouvez maintenant lier les articles importés aux produits que nous avons déjà sur la plateforme, avec tout rempli.",
	noCategory: "Sans catégorie",
	table: {
		systemProduct: "Lien de produits Zig",
	},
	validation: {
		unlinkedCount: {
			one: "1 produit n'a pas été lié. Veuillez lier le produit avant de continuer.",
			other:
				"{count} produits n'ont pas été liés. Veuillez lier tous les produits avant de continuer.",
		},
	},
};
